document.addEventListener('DOMContentLoaded', () => {
  const lazyImages = document.querySelectorAll('img.lazy-load');
  const lazyBgElements = document.querySelectorAll('.lazy-bg');
  const lazyVideoElements = document.querySelectorAll('video.lazy-video');

  const loadImage = img => {
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.classList.remove('lazy-load');
  };

  const loadBg = el => {
    const bgSources = el.getAttribute('data-bg-sources');
    if (bgSources) {
      try {
        const sources = JSON.parse(bgSources);
        if (Array.isArray(sources) && sources.length > 0) {
          const backgroundImages = sources.map(src => `url('${src}')`).join(', ');
          el.style.backgroundImage = backgroundImages;
          el.removeAttribute( 'data-bg-sources');
        }
      } catch (e) {
        console.warn('Invalid data-bg-sources JSON:', bgSources);
      }
    } else {
      const bg = el.getAttribute('data-bg');
      if (bg) {
        el.style.backgroundImage = `url('${bg}')`;
        el.removeAttribute('data-bg');
      }
    }
    el.classList.remove('lazy-bg');
  };

  const loadVideoPoster = el => {
    el.poster = el.dataset.poster;
    el.removeAttribute('data-poster');
    el.classList.remove('lazy-video');
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage(entry.target);
          obs.unobserve(entry.target);
        }
      });
    });

    const bgObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          loadBg(el)
          obs.unobserve(el);
        }
      });
    });

    const videoObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          loadVideoPoster(el)
          obs.unobserve(el);
        }
      });
    });

    lazyImages.forEach(img => {
      observer.observe(img);
    });
    lazyBgElements.forEach(
      el => bgObserver.observe(el)
    );
    lazyVideoElements.forEach(
      el => bgObserver.observe(el)
    );
  } else {
    lazyImages.forEach(loadImage);
    lazyBgElements.forEach(loadBg);
    lazyVideoElements.forEach(loadVideoPoster);
  }
});
